module.exports = __webpack_public_path__ + "media/Blob 16 Joins.17b87047.mp3";